export const create404Error = () => createError({ status: 404, statusText: 'Page Not Found' })

export const show404Error = () => showError({ message: 'Page not found', status: 404 })
